"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Texture_1 = require("../tree/Texture");
const Utils_1 = require("../tree/Utils");
class SvgTexture extends Texture_1.Texture {
    constructor(stage) {
        super(stage);
        this._options = undefined;
        this.pixelRatio = this.stage.pixelRatio;
    }
    set options(options) {
        this._options = options;
        this._changed();
    }
    get options() {
        return this._options;
    }
    _getIsValid() {
        return !!this._options && !!this._options.src && !!this._options.w && !!this._options.h;
    }
    _getLookupId() {
        const { w, h, src } = this._options;
        return "svg" + [w, h, src].join(",") + "|" + this.pixelRatio;
    }
    _getSourceLoader() {
        const options = Utils_1.Utils.clone(this._options);
        return (cb) => {
            const canvas = this.stage.platform.getDrawingCanvas();
            const context = canvas.getContext("2d");
            context.imageSmoothingEnabled = true;
            const img = new Image();
            img.onload = () => {
                const w = options.w * this.pixelRatio;
                const h = options.h * this.pixelRatio;
                canvas.width = w;
                canvas.height = h;
                context.drawImage(img, 0, 0, canvas.width, canvas.height);
                cb(undefined, { source: canvas });
            };
            img.onerror = (err) => {
                return cb(new Error("Image load error: " + err.toString()));
            };
            img.src = options.src;
        };
    }
}
exports.SvgTexture = SvgTexture;
//# sourceMappingURL=SvgTexture.js.map